/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MoveMoneyAlt = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M7.99381 2.01099L8.0471 3.51099L12.4338 3.51099L4.13502 11.8098L5.19568 12.8705L13.4945 4.57166V8.95836L14.9945 9.01166L14.9945 3.51099C14.9945 2.68256 14.3229 2.01099 13.4945 2.01099H7.99381Z"
                        fill={color}
                    />
                    <path
                        d="M3.25105 13.7543C3.64158 14.1449 3.64158 14.778 3.25105 15.1686C2.86053 15.5591 2.22736 15.5591 1.83684 15.1686C1.44631 14.778 1.44631 14.1449 1.83684 13.7543C2.22736 13.3638 2.86053 13.3638 3.25105 13.7543Z"
                        fill={color}
                    />
                    <path
                        d="M22.1667 8.80708C22.5572 9.19761 22.5572 9.83077 22.1667 10.2213C21.7761 10.6118 21.143 10.6118 20.7524 10.2213C20.3619 9.83077 20.3619 9.19761 20.7524 8.80708C21.143 8.41656 21.7761 8.41656 22.1667 8.80708Z"
                        fill={color}
                    />
                    <path
                        d="M9.02075 14.995L10.5208 15.0483L10.5208 19.4351L18.8292 11.1266L19.8899 12.1872L11.5814 20.4957H15.9681L16.0214 21.9957L10.5208 21.9957C9.69232 21.9957 9.02075 21.3241 9.02075 20.4957V14.995Z"
                        fill={color}
                    />
                </svg>
        );
    };
